"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatternTranslator = void 0;
const base_1 = require("../common/base");
const chunk_1 = require("../../chunk/chunk");
const pattern_1 = require("../common/pattern");
class PatternTranslator extends base_1.Translator {
    translate(chunk, actions) {
        const expression = pattern_1.translateChildren(chunk, actions).join(" ");
        const labels = collectLabels(chunk);
        const actionStr = translateAction(chunk.props["action"], labels, actions);
        return `(${expression} ${actionStr})`;
    }
}
exports.PatternTranslator = PatternTranslator;
function translateAction(action, labels, actions) {
    const labels_param = labels.length === 0 ? "" : `${labels.join(", ")}, `;
    const key = `action${actions.size}`;
    actions.set(key, action);
    const actionStr = `{ 
        return actions.get("${key}")({${labels_param}globalFunction});
    }`;
    return actionStr;
}
function collectLabels(chunk) {
    if (!chunk_1.isChunk(chunk)) {
        return [];
    }
    const labels = [];
    if (chunk.props.label) {
        labels.push(chunk.props.label);
    }
    else {
        chunk.children.forEach(child => {
            labels.push(...collectLabels(child));
        });
    }
    return labels;
}
